export function getPopupProps({dataPoint} = {dataPoint: 'Data'}) {
  return {
    content: (
      <span>
        {`Your entered ${dataPoint} will be stored and available for use in the current report for 72 hours.`}
      </span>
    ),
    header: `Enter ${dataPoint}`,
  };
}
